import { render } from "./index.vue?vue&type=template&id=77f2be2b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/pagination/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77f2be2b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77f2be2b', __exports__)) {
    api.reload('77f2be2b', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=77f2be2b", () => {
    api.rerender('77f2be2b', render)
  })

}


export default __exports__